import {
  Button,
  Modal,
} from "@heroui/react";

import { useDeleteTariffCategory } from "@/features/tariffs/use-tariffs.ts";

export function DeleteTariffCategoryModal({
  tariffCategoryId,
  isOpen,
  setIsOpen,
}: {
  tariffCategoryId: number;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) {
  const { mutateAsync, isPending } = useDeleteTariffCategory();

  return (
    <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
      <Modal.Backdrop isDismissable>
        <Modal.Container placement="center">
          <Modal.Dialog>
            <Modal.Header>
              <Modal.Heading>Подтверждение</Modal.Heading>
            </Modal.Header>
            <Modal.Body>Удалить категорию?</Modal.Body>
            <Modal.Footer>
              <Button
                  variant="ghost"
                  onPress={() => setIsOpen(false)}
              >
                Нет, назад
              </Button>

              <Button
                  variant="danger"
                  isPending={isPending}
                  type="submit"
                  onPress={() => mutateAsync({ id: tariffCategoryId })}
              >
                Да, удалить
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  );
}
